import { render, staticRenderFns } from "./AssignedChildrenReport.vue?vue&type=template&id=68ee8140&scoped=true&"
import script from "./AssignedChildrenReport.vue?vue&type=script&lang=js&"
export * from "./AssignedChildrenReport.vue?vue&type=script&lang=js&"
import style0 from "./AssignedChildrenReport.vue?vue&type=style&index=0&id=68ee8140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ee8140",
  null
  
)

export default component.exports